if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/static/serviceWorker.js');
}
